// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './assets/Styles/iconfont.css'
import './assets/Styles/reset.css'
import axios from "axios"
import { Field, Form as vForm, Button, Cell, CellGroup, Notify, Tab, Tabs, Picker, Toast, Popup, Stepper, Checkbox, CheckboxGroup, Area, Loading, Icon, Lazyload, RadioGroup, Radio, NavBar, Col as vCol, Row as vRow, Image as VImage, Swipe as VSwipe, SwipeItem as VSwipeItem } from 'vant'
import 'vant/lib/index.css'
import Headers from './components/OrderHeader/OrderHeader.vue'
import dayjs from 'dayjs'
import wx from 'weixin-js-sdk';
import qs from 'qs'
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
import cookieUtil from './assets/cookieUtil'
Vue.prototype.cookieUtil = cookieUtil
// import VConsole from 'vconsole'
// if (process.env.NODE_ENV === 'production') {
//   new VConsole()
// }
import 'element-ui/lib/theme-chalk/index.css'
import {
  Loading as elLoading,
  Form,
  FormItem,
  Input,
  Row,
  Col,
  Select,
  Option
} from 'element-ui'

Vue.component("headers",Headers)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$wx = wx;

if(localStorage.getItem('kjToken') || cookieUtil.getCookie('kjToken')){
  axios.defaults.headers.common['Authorization'] = localStorage.getItem('kjToken') || cookieUtil.getCookie('kjToken')
}

// 默认带虎门镇的请求头
axios.defaults.headers.common['TownStreet'] = 'HuMenZhen'
// 用户已经选择镇街
if(localStorage.getItem('TownStreetName') || cookieUtil.getCookie('TownStreetName')){
  let TownStreetName = localStorage.getItem('TownStreetName') || cookieUtil.getCookie('TownStreetName')
  store.dispatch('chengeTown', TownStreetName)
}
if(localStorage.getItem('TownStreet') || cookieUtil.getCookie('TownStreet')){
  let id = localStorage.getItem('TownStreet') || cookieUtil.getCookie('TownStreet')
  axios.defaults.headers.common['TownStreet'] = id
}

if (process.env.NODE_ENV === 'development') {
  // axios.defaults.baseURL = 'http://localhost:4067'
  // axios.defaults.baseURL = 'http://192.168.1.249:81'
  axios.defaults.baseURL = 'https://www.lungchuenjz.cn'
} else {
  axios.defaults.baseURL = '/'
}

axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.common['Accept'] = 'application/json'
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.transformRequest = [function (data) {
    return qs.stringify(data)
    }]
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

Vue.use(VueAwesomeSwiper/* { default global options } */)
Vue.use(Field).use(Cell).use(CellGroup).use(Notify).use(Button).use(Tab).use(Tabs).use(Picker).use(Toast).use(Popup).use(Stepper).use(Checkbox).use(CheckboxGroup).use(Area).use(Loading).use(Icon).use(RadioGroup).use(Radio).use(NavBar).use(vCol).use(vRow).use(vForm).use(VImage);
Vue.use(VSwipe).use(VSwipeItem);
Vue.use(elLoading).use(Form).use(FormItem).use(Input).use(Row).use(Col).use(Select).use(Option);
Vue.use(Lazyload, {
  loading: './common/imgs/loading.gif'
})
Vue.use(dayjs)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js